import React, { useState } from "react";
import { Button, TableAdv } from "../../../../components";
import { usePagination } from "../../../../hooks";
import { dateFormator, getEmployeeId, mapTableRows } from "../../../../utils";
import { useEffect } from "react";
import axiosRequest from "../../../../redux/slices/universal/axiosService";
import { ENDPOINTS } from "../../../../redux/apiConfig";

const activityRows = [
  {
    id: 1,
    dateTime: "23-Jun-2025 | 12:27 PM (IST)",
    record: "Venkata Chandu | 20-Aug-2024 to 23-Sep-2024",
    description:
      "Timesheet Status has been changed from (Submit) to (Approved)\nTotal Hours Claimed has been changed from (40:00) to (40:00)",
    updatedBy: "Vikranth Reddy (EMP-052)",
  },
  {
    id: 2,
    dateTime: "13-Sep-2025 | 05:12 PM (IST)",
    record: "Venkata Chandu | 20-Aug-2024 to 23-Sep-2024",
    description:
      "Timesheet for by Dates (1-Oct-2024) to (13-Nov-2025) created by Sumanth Bikkineni.\nStandard Time: 40:00",
    updatedBy: "Sumanth Bikkineni (EMP-2032)",
  },
  {
    id: 3,
    dateTime: "23-Jun-2025 | 12:27 PM (IST)",
    record: "Venkata Chandu | 20-Aug-2024 to 23-Sep-2024",
    description:
      "Timesheet Status has been changed from (Submit) to (Approved)\nTotal Hours Claimed has been changed from (40:00) to (40:00)",
    updatedBy: "Vikranth Reddy (EMP-052)",
  },
  {
    id: 4,
    dateTime: "13-Sep-2025 | 05:12 PM (IST)",
    record: "Venkata Chandu | 20-Aug-2024 to 23-Sep-2024",
    description:
      "Timesheet for by Dates (1-Oct-2024) to (13-Nov-2025) created by Sumanth Bikkineni.\nStandard Time: 40:00",
    updatedBy: "Sumanth Bikkineni (EMP-2032)",
  },
  {
    id: 5,
    dateTime: "13-Sep-2025 | 05:12 PM (IST)",
    record: "Venkata Chandu | 20-Aug-2024 to 23-Sep-2024",
    description:
      "Timesheet for by Dates (1-Oct-2024) to (13-Nov-2025) created by Sumanth Bikkineni.\nStandard Time: 40:00",
    updatedBy: "Sumanth Bikkineni (EMP-2032)",
  },
  {
    id: 6,
    dateTime: "10-May-2025 | 09:45 AM (IST)",
    record: "Ravi Kumar | 01-Jan-2025 to 31-Jan-2025",
    description:
      "Invoice status changed from (Draft) to (Submitted) by Ravi Kumar.\nAmount updated from ($0) to ($12,400)",
    updatedBy: "Ravi Kumar (EMP-0091)",
  },
  {
    id: 7,
    dateTime: "02-Apr-2025 | 03:30 PM (IST)",
    record: "Ananya Sharma | 15-Mar-2025 to 30-Mar-2025",
    description:
      "Funding status changed from (Pending) to (Ready to Fund).\nInvoice Amount: $8,200",
    updatedBy: "Ananya Sharma (EMP-1105)",
  },
  {
    id: 8,
    dateTime: "28-Mar-2025 | 11:00 AM (IST)",
    record: "Kiran Babu | 01-Mar-2025 to 15-Mar-2025",
    description:
      "Timesheet rejected. Reason: Missing client approval signature.",
    updatedBy: "Vikranth Reddy (EMP-052)",
  },
  {
    id: 9,
    dateTime: "15-Feb-2025 | 02:10 PM (IST)",
    record: "Meera Nair | 01-Feb-2025 to 14-Feb-2025",
    description: "Timesheet submitted for approval.\nStandard Time: 32:00",
    updatedBy: "Meera Nair (EMP-3041)",
  },
  {
    id: 10,
    dateTime: "05-Jan-2025 | 10:00 AM (IST)",
    record: "Arjun Patel | 01-Dec-2024 to 31-Dec-2024",
    description:
      "Invoice generated for period Dec 2024.\nInvoice Amount: $15,600",
    updatedBy: "Arjun Patel (EMP-0782)",
  },
  {
    id: 11,
    dateTime: "20-Dec-2024 | 04:55 PM (IST)",
    record: "Sneha Rao | 01-Nov-2024 to 30-Nov-2024",
    description:
      "Chargeback recorded against invoice #987654.\nChargeback Amount: $1,200",
    updatedBy: "Vikranth Reddy (EMP-052)",
  },
];

// Description Cell with Show More / Show Less
const DescriptionCell = ({ value }) => {
  const [expanded, setExpanded] = useState(false);
  const lines = value?.split("\n") || [];
  const hasMore = lines.length > 1;

  return (
    <div>
      <div>{lines[0]}</div>
      {expanded &&
        lines.slice(1).map((line, i) => (
          <div key={i} className="mt-1">
            {line}
          </div>
        ))}
      {hasMore && (
        <button
          onClick={() => setExpanded((prev) => !prev)}
          className="text-info text-sm mt-1 bg-transparent border-0 p-0 cursor-pointer"
        >
          {expanded ? "Show less" : "Show more"}
        </button>
      )}
    </div>
  );
};

const columns = [
  { key: "dateTime", label: "Date & Time" },
  { key: "record", label: "Record" },
  {
    key: "description",
    label: "Description",
    render: (row) => <DescriptionCell value={row?.description} />,
  },
  { key: "updatedBy", label: "Updated By" },
];

const ActivityModal = ({ isOpen, onClose, type }) => {
  console.log({ ActivityModal:type });
  const { page, limit, setPage, handleLimitChange } = usePagination(10);
  const [activity, setActivity] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  
  const mappedRows = mapTableRows(activity, columns);
  
  const fetchReportsActivity = async () => {
    try {
      if(!type) return;
      const params = {
        coll: "Report",
        lim: limit,
        pg: page,
        ret: "addedOn addedBy title",
        ref: "AddedBy",
        fil: JSON.stringify({
          title: {
            type: "NONE",
            value: type,
          }
        }),
        incl: ["firstName lastName"],
        sort: JSON.stringify({ addedOn: 1 }),
      };

      const [response, responseTotal] = await Promise.all([
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.WF_REPORTS.GET_ALL,
          params: params
        }),
        axiosRequest({
          method: "GET",
          url: ENDPOINTS.WF_REPORTS.GET_TOTAL_COUNT,
          params: { coll: "Report", fil: params.fil },
        }),
      ]);
      console.log({ response, responseTotal })
      setTotalCount(responseTotal?.data?.data || 0);
      setActivity(response?.data?.data?.map((item) => ({
        dateTime: item?.addedOn ? dateFormator(item.addedOn,"day-shortMonth-year-time-utc") : "-",
        record: item?.addedBy?.firstName + " " + item?.addedBy?.lastName + [item?.period?.from , item?.period?.to].filter(Boolean).join(" - "),
        description: item?.title,
        updatedBy: item?.addedBy?.firstName + " " + item?.addedBy?.lastName
      })) || []);
    } catch (error) {
      console.error("error block in fetchReportsActivity", error);
    } finally {
    }
  };
  
  useEffect(() => {
    fetchReportsActivity();
  }, [page, limit, type]);

  return (
    <div>
      {/* <Button
        variant="text"
        color="black"
        icon={"arrow_left_alt"}
        title={"Activity"}
        size="lg"
        onClick={onClose}
        className="pl-0! bg-transparent!"
      /> */}
      <TableAdv
        tableId={"activity_section_fundingdashboard"}
          columns={columns}
          rows={mappedRows}
          totalCount={totalCount}
          serverPagination={true}
          page={page}
          limit={limit}
          onPaginationChange={setPage}
          onLimitChange={handleLimitChange}
          toolbarLeft={{
            search: true,
            filter: false,
            download: false,
          }}
        />
    </div>
  );
};

export default ActivityModal;
